import { ChakraProvider } from "@chakra-ui/react";

import popoverTheme from "theme/PopoverTheme";
import { TransportProvider } from "@connectrpc/connect-query";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Main } from "app/Main";
import { transport } from "clients";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

export default function App() {
  return (
    <ChakraProvider theme={popoverTheme}>
      <TransportProvider transport={transport}>
        <QueryClientProvider client={queryClient}>
          <Main />
        </QueryClientProvider>
      </TransportProvider>
    </ChakraProvider>
  );
}
